import { render, staticRenderFns } from "./deduct-info.vue?vue&type=template&id=e050d0b6&scoped=true&"
import script from "./deduct-info.vue?vue&type=script&lang=js&"
export * from "./deduct-info.vue?vue&type=script&lang=js&"
import style0 from "./deduct-info.vue?vue&type=style&index=0&id=e050d0b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e050d0b6",
  null
  
)

export default component.exports